import {Component} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';

@Component({
  selector: 'app-product-qty-max-limit-modal',
  templateUrl: './product-qty-max-limit-modal.component.html',
  styleUrls: ['./product-qty-max-limit-modal.component.scss'],
  imports: [ModalContainerComponent]
})
export class ProductQtyMaxLimitModalComponent {

}
